import { api } from './client';

export interface ContractSummary {
  key: string;
  title: string;
  updated_at: string;
}
export interface ContractDetail extends ContractSummary {
  body: string | null;
}

export const contractsApi = {
  list: () => api.get<{ contracts: ContractSummary[] }>('/contracts').then((r) => r.contracts),
  get: (key: string) => api.get<{ contract: ContractDetail }>(`/contracts/${key}`).then((r) => r.contract),
};
